import { render, staticRenderFns } from "./tags.vue?vue&type=template&id=dba47c52&"
import script from "./tags.vue?vue&type=script&lang=ts&"
export * from "./tags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VChip,VCombobox})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dba47c52')) {
      api.createRecord('dba47c52', component.options)
    } else {
      api.reload('dba47c52', component.options)
    }
    module.hot.accept("./tags.vue?vue&type=template&id=dba47c52&", function () {
      api.rerender('dba47c52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/tags/components/tags.vue"
export default component.exports